import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import CuadroDatos from '../../UI/CuadroDatos.js';
import TablaDatos from '../../UI/TablaDatos.js';
import { OrdenarListaFechaDesc } from '../../funciones/FuncionesTorneos.js';
import useGetListaURL from '../../../hooks/useGetListaURL.js';
import styles from './CampeonesInt.module.css';
import { NombreEquipo } from '../../funciones/FuncionesEquipo.js';

const CampeonesInt = (props) => {
  const tipoTorneo = props.tipoTorneo;
  const categoria = props.categoria;
  const [campeones, setCampeones] = useState([]);
  const { isCargando, erroresGetLista, fetchData, resetErroresGetLista } = useGetListaURL();

  useEffect(() => {
    resetErroresGetLista();
  }, [resetErroresGetLista]);

  useEffect(() => {
    const ordenarTorneos = (lista) => {
      const listaFiltrada = lista.filter((item) => item.fechaFin !== null);
      if (listaFiltrada) {
        setCampeones(OrdenarListaFechaDesc(listaFiltrada));
      } else {
        setCampeones([]);
      }
    };

    if (tipoTorneo) {
      let URL = 'tipos_torneo/' + tipoTorneo.codigo + '/campeones';
      if (categoria) {
        URL += '?categoria=' + categoria.codigo;
      }
      fetchData(URL, ordenarTorneos);
    } else {
      setCampeones([]);
    }
  }, [tipoTorneo, categoria, fetchData]);

  return (
    <div className={`${styles.cuadro}`}>
      <CuadroDatos
        titulo={'Campeones'}
        mostrar={true}
        isCargando={isCargando}
        error={erroresGetLista}
      >
        <TablaDatos
          estilo={`${styles.tablaDatos}`}
          lista={campeones}
          textoVacia="No hay datos a mostrar"
        >
          <tbody>
            <tr className={`${styles.titulos}`} key="0">
              <td className={`${styles.torneo}`}>Torneo</td>
              <td className={`${styles.campeon}`}>Campeón</td>
              <td className={`${styles.campeon}`}>SubCampeón</td>
            </tr>
            {campeones &&
              campeones.map((item) => (
                <tr className={`${styles.valores}`} key={item.id}>
                  <td className={`${styles.torneo}`}>
                    <Link to={'/torneos/' + item.id}>{item.temporada}</Link>
                  </td>
                  <td className={`${styles.campeon}`}>
                    {item.campeon && (
                      <Link to={'/torneos/' + item.id + '/equipo/' + item.campeon.id}>
                        {NombreEquipo(item.campeon)}
                      </Link>
                    )}
                  </td>
                  <td className={`${styles.campeon}`}>
                    {item.subCampeon && (
                      <Link to={'/torneos/' + item.id + '/equipo/' + item.subCampeon.codigo}>
                        {NombreEquipo(item.subCampeon)}
                      </Link>
                    )}
                  </td>
                </tr>
              ))}
          </tbody>
        </TablaDatos>
      </CuadroDatos>
    </div>
  );
};

export default CampeonesInt;
